import { COLOR } from "../../../../common/Color"
import { PhaserText } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"


export class RoundNumberContainer {
    numbers: Array<RoundNumber>
    private current: RoundNumber

    private set active(round: RoundNumber) {
        this.current = round
        this.current.top.activeText()
        this.current.side.show()
    }

    constructor(private game: Phaser.Game, private group: Phaser.Group, private roundNumber: number) {
        this.numbers = [
            {top: new TopRoundNumber(game, group, 1, Scale.x(0.55), Scale.y(0.145)), side: new SideRoundNumber(game, group, 1)},
            {top: new TopRoundNumber(game, group, 2, Scale.x(0.65), Scale.y(0.145)), side: new SideRoundNumber(game, group, 2)},
            {top: new TopRoundNumber(game, group, 3, Scale.x(0.75), Scale.y(0.145)), side: new SideRoundNumber(game, group, 3)},
            {top: new TopRoundNumber(game, group, 4, Scale.x(0.85), Scale.y(0.145)), side: new SideRoundNumber(game, group, 4)},
            {top: new TopRoundNumber(game, group, 5, Scale.x(0.95), Scale.y(0.145)), side: new SideRoundNumber(game, group, 5)},
        ]

        this.active = this.numbers[roundNumber]
    }

    changeRound = (round: number) => {
        if (round >= 0 && round < this.numbers.length) {
            this.current.top.inactiveText()
            this.current.side.hide()
            this.active = this.numbers[round]
        }
    }

    changeSideColor = (color: string) => this.current.side.setColor(color)
}

interface RoundNumber {
    top: TopRoundNumber
    side: SideRoundNumber
}

class TopRoundNumber {
    text: Phaser.Text

    constructor(
        private game: Phaser.Game,
        private group: Phaser.Group,
        private roundNum: number,
        private x: number,
        private y: number
    ) {
        this.text = PhaserText.create(game, roundNum.toString(), {x, y, color: COLOR.white, group})
        this.text.anchor.set(0.5, 0.5)
    }

    activeText = () => {
        this.text.fontSize = 48
    }

    inactiveText = () => {
        this.text.fontSize = 24
    }
}

class SideRoundNumber {
    text: Phaser.Text

    constructor(private game: Phaser.Game, private group: Phaser.Group, private roundNum: number) {
        this.text = PhaserText.create(game, roundNum.toString(), {x: Scale.x(0.02), y: Scale.y(0.22), color: COLOR.black, group, debug: true})
        this.hide()
    }

    show = () => this.text.visible = true

    hide = () => this.text.visible = false

    setColor = (color: string) => this.text.fill = color
}

